import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
// import { OrganizationSetupCommon } from './../organization-setup.common';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-ctc-details-report',
  templateUrl: './ctc-details-report.component.html',
  styleUrls: ['./ctc-details-report.component.css']
})
export class CtcDetailsReportComponent implements OnInit {

  selectedBranch = null;
  branchList: any;
  selectedFY = null;
  financialYearList: any;

  modalFormObjList: any;
  modalForm: any;

  // formErrors = OrganizationSetupCommon.holidayFormErrors;
  // formValidationMessages = OrganizationSetupCommon.holidayFormValidationMessages;

  constructor(private organizationSetupService: OrganizationSetupService,
      private masterDataService: MasterDataService,
      private fb: FormBuilder, private modalService: NgbModal,
      private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.loadBranch();
  }

  loadBranch() {
    this.masterDataService.getBranch()
      .subscribe(res => {
        console.log(res);
        this.branchList = res;
        // const branchIndex = this.branchList.findIndex(item => item.id == 1);

        var branchIndex = 0;
        // this.branchList.forEach((element, key) => {
        //   if (element.name == 'Pune') {
        //     branchIndex = key;
        //   }
        // });
        // this.selectedBranch = this.branchList[branchIndex];
        // console.log("intit branch", this.branchList[branchIndex])
        // this.selectedBranch = this.branchList[branchIndex]
        this.loadFinancailYear();
      });

  }

   loadFinancailYear() {
      this.masterDataService.getFinancialYear()
        .subscribe(res => {
          console.log("years :", res);
          this.financialYearList = res;
          // var fyIndex = -1;
          // this.financialYearList.forEach((element, key) => {
          //   var startDate = new Date(element.startDate);
          //   var endDate = new Date(element.endDate);
          //   // var currentDate = new Date();
          //   var currentDate = moment(new Date()).format("YYYY-MM-DD");
          //   console.log(startDate, endDate);;
          //   console.log(currentDate + " " + element.startDate + " " + element.endDate);
          //   // if(currentDate>=startDate && currentDate<=endDate){
          //   //   fyIndex = key;
          //   // }
          //   if (currentDate >= element.startDate && currentDate <= element.endDate) {
          //     fyIndex = key;
          //   }
          //   console.log("fyIndex", fyIndex)
          // });
          // console.log("financialYearList[fyIndex]", this.financialYearList[fyIndex])
          // this.selectedFY = this.financialYearList[fyIndex];
          // console.log("this.selectedFY", this.selectedFY)
         
        });
  
    }
  
  onViewReport() {
    console.log("this.selectedBranch.id", this.selectedBranch.id);
    console.log("this.selectedBranch.id", this.selectedFY.id);
    if (this.selectedBranch == 'Select' || this.selectedFY == 'Select') {
      this.commonMessageService.swalAlertWithoutIcon('','Please select both the fields')
    } else {
      this.organizationSetupService.getCtcDetails(this.selectedBranch.id, this.selectedFY.id)
        .subscribe(res => {
          console.log(res);
          this.modalFormObjList = res;
          console.log("this.modalFormObjList", this.modalFormObjList)
        });
    }
  }

  

}
